import {cva, type VariantProps} from 'class-variance-authority'

export {default as Button} from './Button.vue'

export const buttonVariants = cva(
    'w-full inline-flex items-center justify-center text-sm text-ellipsis border-0 active:scale-[0.98] cursor-pointer transition-transform select-none  whitespace-nowrap ring-offset-background focus-visible:outline-1 transform-gpu will-change-transform disabled:pointer-events-none',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground font-semibold',
                defaultRounded: 'bg-neutral-100 text-foreground font-semibold border-[0.5px] border-input !rounded-full',
                destructive:
                    'bg-destructive text-destructive-foreground hover:bg-destructive/95 font-semibold',
                outline: 'border border-input bg-background font-semibold',
                outlineRounded: 'border-[0.5px] border-input bg-background font-semibold !rounded-full',
                secondary:
                    'bg-secondary text-secondary-foreground hover:bg-secondary/80 font-semibold',
                ghost: 'hover:bg-accent hover:text-accent-foreground font-semibold',
                table: 'hover:bg-gray-800 hover:text-white font-semibold transition-all duration-200',
                link: 'text-primary underline-offset-2 hover:underline font-semibold',
                muted: 'text-gray underline-offset-2 hover:underline font-normal',
                icon: 'group relative flex items-center justify-center active:scale-[0.85] transition-transform',
                action: 'relative flex items-center justify-center scale-100 active:scale-100 text-white bg-transparent hover:text-white/80 active:opacity-50 transition-all',
                counter: 'group relative flex items-center justify-center active:scale-[0.85] transition-transform'
            },
            size: {
                default: 'rounded-lg h-[2.125rem] px-4',
                lg: 'rounded-full h-9 px-4',
                icon: '',
                reaction: 'w-9 h-9',
                xl: 'rounded-xl p-4 h-14',
            },
            pending: {
                true: '!cursor-not-allowed opacity-80'
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
            pending: false
        },
    },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
